// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"754":"63347c7f","945":"cb60293e"}[chunkId] + ".chunk.css";
};